import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "debug-component" }

import TopDebugComponentTool1 from './tool1.vue';
import type { DebugToolProps } from 'src/models/top';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    refExtremeMap: {},
    cars: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-primary" }, [
      _createElementVNode("ul", { class: "memo-text" }, [
        _createElementVNode("li", null, "※ここはsuper admin権限でログインした場合のみ表示される開発者用領域です。"),
        _createElementVNode("li", null, "※検索系ボタンはサーバに検索リクエストが飛び一応多少のシステム負荷がかかるので、あまり連打はしないでください。")
      ])
    ], -1)),
    _createVNode(TopDebugComponentTool1, {
      "ref-extreme-map": __props.refExtremeMap,
      cars: __props.cars
    }, null, 8, ["ref-extreme-map", "cars"])
  ]))
}
}

})